export enum Constants {
    ADD_MODULE = 'ADD_MODULE',
    ADD_MODULES = 'ADD_MODULES',
    UPDATE_MODULE = 'UPDATE_MODULE',
    REMOVE_MODULE = 'REMOVE_MODULE',
    REMOVE_MODULES = 'REMOVE_MODULES'
}
